import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from "rxjs";
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { LoaderService } from "./services/loader.service";
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from "./services/common.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LogOutModel } from "./models/common";
import { AesEncriptionDecriptionService } from "./services/common/aes-encription-decription.service";
@Injectable()
export class GlobalHttpInterceptorService implements HttpInterceptor {

  private requests: HttpRequest<any>[] = [];
  ExcludeURLList = [
    // environment.baseUrl + "/api/Common/commonFileuploaddata",
    // environment.baseUrl + "/api/Users/UploadProfilePicture",
    // environment.baseUrl + "/api/Common/downloadattachedfile"
];
  constructor(
    public router: Router,
    private userService: UserService,
    private loaderService: LoaderService,
    public modalRef: NgbActiveModal,
    private modalService:NgbModal,
    private commmonService: CommonService,
    private encryptDecryptService:AesEncriptionDecriptionService

  ) {

  }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let handled: boolean = false;

    // If token is present, send with request
    const token =this.userService.getToken();

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    this.requests.push(req);
    if(req.url.indexOf("api/Notifications/NotificationCount") == -1)   {       
      this.loaderService.isLoading.next(true);
    }
    return new Observable((observer => {
      const subscription = next.handle(req)
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {
              this.removeRequest(req);
              observer.next(event);
            }
          },
          err => {
          
            // alert('error' + err);
            switch (err.status) {
              case 401:      //login
                this.logout();
                //console.log('redirect to login');
                handled = true;
                break;
              case 403:     //forbidden
                this.logout();
                //console.log('redirect to login');
                handled = true;
                break;
              case 803:     //forbidden
             const Modalref= this.modalService.open(MessageBoxComponent, 
                { backdrop: false});
               Modalref.componentInstance.Content =  { 
                heading: 'Session-Timeout',
                 content: { heading: '', description: 'Session expired please login again' }
                 } ;
              handled = true;
             // this.logout('Session Timeout')
              setTimeout(x=>this.logout('Session Timeout'),200);
                break;
            }
            this.removeRequest(req);
            observer.error(err);
          },
          () => {
            this.removeRequest(req);
            observer.complete();
          });
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    }));

    /* return next.handle(req).pipe(
      catchError((error) => {
        switch (error.status) {
          case 401:      //login
            this.logout();
            console.log(`redirect to login`);
            handled = true;
            break;
          case 403:     //forbidden
            this.logout();
            console.log(`redirect to login`);
            handled = true;
            break;
        }

        //if (error.status == 403)
        //  console.log('error is intercept')
        //console.error(error);

        if (handled) {
          console.log('return back ');
          return of(error);
        } else {
          console.log('throw error back to to the subscriber');
          return throwError(error);
        }
      })
    ) */
  }

  logout(LogOutReason: string = '') {
    let orgCode = this.userService.getOrgCode();
    let user = this.userService.getUserDetais();
    //localStorage.clear();
    //this.modalRef.hide();
    let browserName = this.userService.detectBrowserName();

    let model = new LogOutModel();
    model.Browser = browserName.name;
    model.Reason = LogOutReason;
    model.Version = browserName.version;
    model.UserId= user.ID;

    this.userService.userLogout(model).subscribe(result => {
    
      if(result.Status == 0){
        localStorage.clear();
       
        if (orgCode !== null && orgCode !== "undefined" && orgCode !== '') {
          //this.router.navigateByUrl(orgCode + '/login');        
          window.location.replace(orgCode + '/login');
          
        }
        else {
         // this.router.navigateByUrl('/login');        
          window.location.replace('/login');
          
        }
      }     
    });
  }

  EncriptRequestData(req, next) {
    let exludeFound = this.ExcludeURLList.filter(element => {
      return req.url.includes(element)
    });
    // We have Encrypt the GET and POST call before pass payload to API
    if (!(exludeFound && exludeFound.length > 0)) {
      if (req.method == "GET") {
        if (req.url.indexOf("?") > 0) {
          // let encriptURL = req.url.substr(0, req.url.indexOf("?") + 1) + this.encryptDecryptService.encryptionAES(req.url.substr(req.url.indexOf("?") + 1, req.url.length));
          // req = req.clone({
          //   url: encriptURL
          // });
          return req;
        }
        return req;
      } else if (req.method == "POST") {
        if (req.body || req.body.length > 0) {
      // debugger;
        if(req.url.indexOf("/department/update")>-1)
        {
          // let localbody=  this.encryptDecryptService.EncryptRequest(JSON.stringify(req.body))
          // req = req.clone({
          //   body: localbody
          // });
        }
          
          return req;
        }
        return req;
      }
    }
  }
}
